<template>
    <el-dialog :visible.sync="boxVisible" v-if="boxVisible" class="myDialog ConfirmBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true">
        <div class="ConfirmBox-body">
            <i class="el-icon-circle-close ConfirmBox-close" @click="close"></i>
            <div class="ConfirmBox-title">{{$t('common.confirmByWallet')}}</div>
            <div class="ConfirmBox-content">
                <div class="loading">
                     <i class='el-icon-loading'></i>
                </div>
                <div class="step-progress">
                    <el-steps v-if="type == 3" :active="stepNum" finish-status="success">
                        <el-step :title="token1 +' '+ $t('common.approve')"></el-step>
                        <el-step :title="token2 +' '+ $t('common.approve')"></el-step>
                        <el-step :title="$t('common.sign')"></el-step>
                    </el-steps>
                    <el-steps v-if="type == 2" :active="stepNum" finish-status="success">
                        <el-step :title="token1+' '+ $t('common.approve')"></el-step>
                        <el-step :title="$t('common.sign')"></el-step>
                    </el-steps>
                    <el-steps v-if="type == 1" :active="stepNum" finish-status="success">
                    </el-steps>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name:"ConfirmBox",
    data() {
        return {
            boxVisible:false,
            type:0,
            stepNum:1,
            token1:"",
            token2:"",
        };
    },
    created() {
    },
    methods:{
        show(type,token1,token2) {
            this.boxVisible = true;
            this.type = type;
            this.stepNum = 1;
            this.token1 = token1;
            this.token2 = token2;
        },
        close() {
            this.boxVisible = false;
            clearInterval(window.checkTradeTimer);
        },
        setSetNum(stepNum){
            this.stepNum = stepNum;
        }
    }
}
</script>

<style lang="less">
.ConfirmBox{
    // background-color:rgba(0,0,0,0.8)!important;
    display: flex;
    div.el-dialog{
        background: none !important;
        width: 100%;
        margin: 0px 10px;
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 0px !important;
            .ConfirmBox-body {
                // background: #ffffff;
                padding: 25px 0px 20px 0px;
                border-radius: 10px;
                text-align: center;
                position: relative;
                .ConfirmBox-close{
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    cursor: pointer;
                    font-size: 20px;
                    color: #4f76e1;
                }
                .ConfirmBox-title {
                    color: #ffffff;
                    font-weight: bolder;
                    font-size: 18px;
                    margin:10px 0px 20px 0px;
                }
                .ConfirmBox-content{
                    margin: 15px 15px;
                }
            }
        }
    }
    .loading{
        margin:0px auto;
        width:120px;
        height:120px;
        color:#0084FF;
        font-size:20px;
        display:flex;
        align-items:center;
        justify-content:center;
    }
    .step-progress{
        width:100%;
        .el-step__head{
            display:flex;
        }
        .el-step__line{
            // background-color:#0084FF;
        }
        .el-step__head.is-process,.el-step__head.is-wait{
            color: #9ABCDF;
            border-color: #9ABCDF;
        }
        .el-step__title.is-process,.el-step__title.is-wait{
            color:#9ABCDF;
            font-size:13px;
            font-weight: 400;
        }
        
        .el-step__head.is-success{
            color: #1C1C1E;
            border-color: #ffffff;
            .el-step__icon.is-text{
                color: #006CEA;
            }
        }
        .el-step__title.is-success{
            // color: #0084FF;
            font-size:13px;
            font-weight: 600;
            background: -webkit-linear-gradient(90deg, #32D8FF, #006CEA);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        } 
    }
}
</style>
